import React, { useContext, useEffect, useState } from 'react';
import { 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader,
  useColorModeValue,
  Text,
  ModalCloseButton,
  Spinner
} from '@chakra-ui/react';
import { AppContext } from '../../../context/AppContext';
import axios from 'axios';

const TermsPrivacy = () => {
  const { 
    termsState, 
    setTermsState, 
    privacyState, 
    setPrivacyState 
} = useContext(AppContext);
    console.log("🚀 ~ TermsOfUse ~ privacyState:", privacyState)

  const textColor = useColorModeValue("gray.700", "white");

  
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false)

  const getPrivacyPolicy = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://hubapi.gridgamers.com/api/v1/setting/privacypolicy-termscondition?SubCatagoryId=12');
      const { data } = res;
      const { response } = data;
      
      setDescription(response.subCategoryDescription);

      setLoading(false)
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };

  const getTermsOfUse = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://hubapi.gridgamers.com/api/v1/setting/privacypolicy-termscondition?SubCatagoryId=13');
      const { data } = res;
      const { response } = data;

      setDescription(response.subCategoryDescription);

      setLoading(false)
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };

  useEffect(() => {
    if(termsState){
        getTermsOfUse();
    }if(privacyState){
        getPrivacyPolicy();
    }
  }, [termsState,privacyState]);

  const OverlayOne = () => (
    <ModalOverlay bg='blackAlpha.500' />
  );

  const [overlay, setOverlay] = useState(<OverlayOne />);

  const onClose = () => {
    setTermsState(false);
    setPrivacyState(false)
  };

  return (
    <Modal isCentered isOpen={termsState || privacyState} onClose={onClose} size="5xl" scrollBehavior={'inside'}>
      {overlay}
      <ModalOverlay bg="blackAlpha.100" />
      <ModalContent marginLeft={{ xl: "250px", md: "0px" }} width={{ sm: "90%" }}>
        <ModalCloseButton />
        <ModalHeader>
          <Text
            fontSize='xl'
            color={textColor}
            fontWeight='bold'
            textAlign='center'
          >
            { termsState && "Terms of Use" }
            { privacyState && "Privacy Policy" }
          </Text>
        </ModalHeader>
            <ModalBody textAlign="center">
            {loading ?
            <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='blue.500'
                size='xl'
            />
                :
            <Text
                color="#718096"
                textAlign='start'
                fontSize="md"
                marginLeft="1"
                dangerouslySetInnerHTML={{ __html: description }} // Render HTML safely
            />
            }
            </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TermsPrivacy;
